import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { PAYLOAD_ID } from "../../../types/enums";
import { PASSWORD_SOURCE } from "../types/enums";
import PasswordInputField from "./PasswordInputField";
import PasswordValidation from "./PasswordValidation";
import { EnteredPasswordProps, PASSWORD_TYPES } from "./types";

const EnteredPassword = ({
    password,
    changePayload,
    changePassword
}: EnteredPasswordProps) => {
    const { t } = useTranslation();

    const { first, repeat } = password;

    const handleChangePayload = (areRulesMet: boolean) => {
        const payload = areRulesMet
            ? {
                  id: PAYLOAD_ID.Attributes,
                  value: JSON.stringify({
                      password_source: PASSWORD_SOURCE.UserEntered,
                      password: first
                  })
              }
            : null;

        changePayload(payload);
    };

    return (
        <div
            css={css({
                marginTop: "16px",

                "& > div:nth-of-type(2)": {
                    margin: "16px 0"
                }
            })}
        >
            <PasswordInputField
                name={PASSWORD_TYPES.First}
                value={first}
                label={t("Dialog##set bluetooth password##bluetooth password")}
                onChange={changePassword}
            />

            <PasswordInputField
                name={PASSWORD_TYPES.Repeat}
                value={repeat}
                label={t(
                    "Dialog##set bluetooth password##repeat bluetooth password"
                )}
                onChange={changePassword}
            />

            <PasswordValidation
                password={first}
                repeatPassword={repeat}
                onRulesMet={handleChangePayload}
            />
        </div>
    );
};

export default EnteredPassword;
